<div>
    <div>
        <ul class="border border-primary rounded">
            <li class="border-primary" *ngFor="let domain of domains">
                <app-subdomain-navigation [domain]="domain">
                    <ng-template let-data>
                        <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
                    </ng-template>
                </app-subdomain-navigation>
            </li>
        </ul>
    </div>
</div>
